export const Loader = () => {
    return (
        <div className="min-h-full items-center flex justify-center font-semibold text-4xl">
            Loading....
        </div>
    )
}
